module.exports = __webpack_public_path__ + "img/slogan.6c1b57f4.png";